import { emitter } from 'shared/helpers/mitt';
import analyticsHelper from 'dashboard/helper/AnalyticsHelper/index';

/**
 * Custom hook to track events
 */
export const useTrack = (...args) => {
  try {
    return analyticsHelper.track(...args);
  } catch (error) {
    // Ignore this, tracking is not mission critical
  }

  return null;
};

/**
 * Composable for showing toast/alert messages.
 *
 * Backward-compatible with BOTH call styles:
 *   useAlert('Saved!')                       -> shows the toast immediately
 *   const { showAlert } = useAlert(); showAlert('Saved!')
 *
 * Audit 2026-06-16: commit c8caa8637c changed this from a direct function
 * `useAlert(message)` to a composable returning `{ showAlert }` (to allow
 * destructuring), but the ~465 existing direct `useAlert(message)` call sites
 * were not migrated, so their toasts silently stopped showing. Accepting the
 * optional message argument restores the direct behaviour while keeping the
 * destructure pattern working.
 *
 * @param {string} [message] Optional message; when provided, the toast is shown immediately.
 * @param {Object} [action] Optional toast action.
 * @returns {Object} An object with a showAlert method.
 */
export const useAlert = (message, action = null) => {
  const showAlert = (msg, act = null) => {
    emitter.emit('newToastMessage', { message: msg, action: act });
  };

  if (message !== undefined) {
    showAlert(message, action);
  }

  return {
    showAlert,
  };
};
